module.exports = __webpack_public_path__ + "static/media/bbc_news_magazine-35846207_plot.95eaa8f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/bbc_news_magazine-35846207_plot.png
// module id = 357
// module chunks = 0